<template>
  <div>
    <!--头部开始 -->
    <top-part></top-part>
    <!-- 头部结束 -->
    <!-- 中间内容开始 -->
    <div class="content-box">
      <div>
        <h1 class="content-title">{{systemData.title}}</h1>
        <div class="text-box" v-html="systemData.content"></div>
      </div>
      <div v-if="noDate">
        <van-empty
          class="custom-image"
          :image="require('../../assets/images/null@2x.png')"
          description="暂无数据"
        />
      </div>
    </div>
    <!-- 中间内容结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
export default {
  components: {
    topPart
  },
  data() {
    return {
      systemData: {}, //页面显示数据
      noDate: false //控制暂无数据是否显示
    };
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    // 获取积分制度
    getSystem() {
      var that = this;
      this.centralControl.axios.centralControl(
        "integralSystem",
        res => {
          if (res.code == 200) {
            if (JSON.stringify(res.data) === "{}") {
              that.noDate = true;
              return;
            }
            this.systemData = res.data;
            console.log(res.data);
          } else {
            that.$message.error(res.message);
          }
        },
        { type: "point" }
      );
    },
    init() {
      this.getSystem();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/common.styl';

.text-box >>> img {
  width: 100%;
}

.content-box {
  myContent();
  background: #fff;
}

.return-text {
  color: #353535;
}

.content-title {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(53, 53, 53, 1);
  line-height: 25px;
  text-align: center;
  margin: 15px;
}

.text-box {
  margin: 10px;
  text-align: left;
  font-size: 14px;
  line-height: 18px;

  p {
    font-size: 15px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 25px;
    letter-spacing: 1px;
  }
}
</style>